import type { RecapArticleSummary } from '../types';

const POSITIVE_SENTIMENT_LABELS: Record<number, string> = {
  5: 'Very Positive',
  4: 'Positive',
};

export function RecapArticleRow({ article }: { article: RecapArticleSummary }) {
  const sentimentLabel = POSITIVE_SENTIMENT_LABELS[article.sentiment];

  return (
    <a
      href={article.link}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex gap-4 rounded-xl p-3 transition-colors hover:bg-neutral-100 dark:hover:bg-neutral-700/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
    >
      {article.imageUrl && (
        <img
          src={article.imageUrl}
          alt=""
          className="h-16 w-24 flex-shrink-0 rounded-lg object-cover"
          loading="lazy"
        />
      )}
      <div className="min-w-0 flex-1">
        <h4 className="line-clamp-2 text-sm font-semibold text-neutral-900 group-hover:text-primary dark:text-white dark:group-hover:text-primary">
          {article.title}
          <span className="sr-only"> (opens in new tab)</span>
        </h4>
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-neutral-500 dark:text-neutral-400">
          <span>{article.provider}</span>
          {sentimentLabel && (
            <>
              <span aria-hidden="true">&middot;</span>
              <span>{sentimentLabel}</span>
            </>
          )}
          {article.likeCount > 0 && (
            <>
              <span aria-hidden="true">&middot;</span>
              <span>
                {article.likeCount} {article.likeCount === 1 ? 'like' : 'likes'}
              </span>
            </>
          )}
        </div>
      </div>
    </a>
  );
}
